module.exports = __webpack_public_path__ + "fonts/10141a9.eot";